import React from "react";
import { Box, Typography } from "@mui/material";

const ServiceItem = ({ label, path, isActive, isLaunched, onClick }) => (
  <Box
    onClick={() => onClick(path, isActive, isLaunched)}
    sx={{
      display: "flex",
      alignItems: "center",
      justifyContent: "space-between",
      px: 1.5,
      py: 1.1,
      borderRadius: 2,
      cursor: isActive ? "pointer" : "default",
      color: isActive ? "#1A1A1A" : "#B0B0B0",
      transition: "all 0.2s ease",
      "&:hover": isActive
        ? {
            color: "#FD7762",
            backgroundColor: "#FAFAFA",
            transform: "translateX(2px)",
          }
        : {},
    }}>
    <Typography sx={{ fontSize: "16px", fontWeight: 500 }}>{label}</Typography>
    {isActive && !isLaunched && (
      <Box
        sx={{
          fontSize: "0.6rem",
          px: 1,
          py: 0.4,
          borderRadius: "999px",
          backgroundColor: "#E2B93B",
          fontWeight: 700,
          color: "#1A1A1A",
          letterSpacing: 0.5,
          textTransform: "lowercase",
          ml: 1,
          boxShadow: "inset 0 0 2px rgba(0,0,0,0.1)",
        }}>
        Coming Soon
      </Box>
    )}
    {isActive && isLaunched && (
      <Box
        sx={{
          fontSize: "0.6rem",
          px: 1,
          py: 0.8,
          borderRadius: "999px",
          backgroundColor: "#C3F584",
          fontWeight: 700,
          color: "#1A1A1A",
          letterSpacing: 0.5,
          textTransform: "lowercase",
          ml: 1,
          boxShadow: "inset 0 0 2px rgba(0,0,0,0.1)",
        }}>
        New Launch
      </Box>
    )}
  </Box>
);

export default ServiceItem;
